import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";

const NumberInputDialog = (props) => {
  const { title, children, open, setOpen, onConfirm } = props;
  const [inputValue, setInputValue] = useState("");

  const handleConfirm = () => {
    const numericValue = parseFloat(inputValue);
    if (!isNaN(numericValue)) {
      setOpen(false);
      onConfirm(numericValue);
      setInputValue(""); // Reset input after confirm
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setInputValue(""); // Reset input on cancel
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="number-input-dialog"
    >
      <DialogTitle id="number-input-dialog">{title}</DialogTitle>
      <DialogContent>
        {children}
        <TextField
          autoFocus
          margin="dense"
          label="Enter a number"
          type="number"
          fullWidth
          variant="outlined"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleConfirm();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleConfirm}
          disabled={!inputValue || isNaN(parseFloat(inputValue))}
        >
          Confirm
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NumberInputDialog;
